var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonospaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.021 2.906c.186 1.219.372 1.5.372 2.719C1.393 6.375 0 7.031 0 7.031v.938s1.393.656 1.393 1.406c0 1.219-.186 1.5-.372 2.719C.743 14.063 1.764 15 2.693 15h1.95v-1.875s-1.672.188-1.672-.938c0-.843.186-.843.372-2.718.093-.844-.464-1.5-1.022-1.969.558-.469 1.115-1.031 1.022-1.875C3.064 3.75 2.97 3.75 2.97 2.906c0-1.125 1.672-1.031 1.672-1.031V0h-1.95C1.67 0 .743.938 1.02 2.906zM11.979 2.906c-.186 1.219-.372 1.5-.372 2.719 0 .75 1.393 1.406 1.393 1.406v.938s-1.393.656-1.393 1.406c0 1.219.186 1.5.372 2.719.278 1.969-.743 2.906-1.672 2.906h-1.95v-1.875s1.672.188 1.672-.938c0-.843-.186-.843-.372-2.718-.093-.844.464-1.5 1.022-1.969-.558-.469-1.115-1.031-1.022-1.875.186-1.875.372-1.875.372-2.719 0-1.125-1.672-1.031-1.672-1.031V0h1.95c1.022 0 1.95.938 1.672 2.906z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonospaceIcon);
export default __webpack_public_path__ + "static/media/monospace-icon.68e9ae80be0adfcb6d11134dd87e76c9.svg";
export { ForwardRef as ReactComponent };